import { render, staticRenderFns } from "./ShowFacility.vue?vue&type=template&id=48174509&scoped=true"
import script from "./ShowFacility.vue?vue&type=script&lang=js"
export * from "./ShowFacility.vue?vue&type=script&lang=js"
import style0 from "./ShowFacility.vue?vue&type=style&index=0&id=48174509&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48174509",
  null
  
)

export default component.exports